import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "../../../../../utils/constants";
import { useBackdropContext } from "../../../../../contexts/backdrop/BackdropProvider";
import { asyncSearchList } from "../../../../../utils/httpRequests";
import ModuleComponent from "./ModuleComponent";
import SocialCategories from "./SocialCategories";

type ModuleType = {
  _id: string;
  title: string;
  code: string;
  rights: string[];
  extraComponent?: React.ComponentType<any>;
};

const allRight: string[] = [
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
  ADD_RIGHT,
  UPDATE_RIGHT,
  DELETE_RIGHT,
];

const modules: ModuleType[] = [
  {
    _id: "posts",
    code: "posts",
    title: "Bài Feed",
    rights: allRight,
  },
  {
    _id: "forumposts",
    code: "forumposts",
    title: "Bài Forum",
    rights: allRight,
    extraComponent: SocialCategories,
  },
  {
    _id: "socialcategories",
    code: "socialcategories",
    title: "Danh mục forum",
    rights: allRight,
  },
  {
    _id: "topics",
    code: "topics",
    title: "Chủ đề forum",
    rights: allRight,
  },
  {
    _id: "reportlist",
    code: "reportlist",
    title: "Tố cáo bài viết",
    rights: allRight,
  },
  {
    _id: "hashtags",
    code: "hashtags",
    title: "Hashtag",
    rights: allRight,
  },
  {
    _id: "socialcomment",
    code: "socialcomment",
    title: "Bình luận",
    rights: allRight,
  },
  {
    _id: "banner",
    code: "banner",
    title: "Hình ảnh",
    rights: allRight,
  },
  {
    _id: "comment2",
    code: "comment2",
    title: "Liên hệ",
    rights: allRight,
  },
  {
    _id: "group",
    code: "group",
    title: "Nhóm liên hệ",
    rights: allRight,
  },
  {
    _id: "participant",
    code: "participant",
    title: "Người dùng",
    rights: [ADD_RIGHT, UPDATE_RIGHT, DELETE_RIGHT],
  },
  {
    _id: "usergroup",
    code: "usergroup",
    title: "Nhóm người dùng",
    rights: allRight,
  },
  {
    _id: "fos_rpusers",
    code: "fos_rpusers",
    title: "Thống kê người dùng",
    rights: [VIEW_RIGHT, VIEWOFOTHER_RIGHT],
  },
  {
    _id: "fos_rpposts",
    code: "fos_rpposts",
    title: "Thống kê bài đăng",
    rights: [VIEW_RIGHT, VIEWOFOTHER_RIGHT],
  },
  {
    _id: "fos_rpcomments",
    code: "fos_rpcomments",
    title: "Thống kê bình luận",
    rights: [VIEW_RIGHT, VIEWOFOTHER_RIGHT],
  },
];

interface IPhanquyenSection {
  data: any;
}

function PhanquyenSection({ data }: IPhanquyenSection) {
  const { setOpenBackdrop } = useBackdropContext();
  const [rightObj, setRightObj] = useState<any>({});

  // get rights
  const getRights = async () => {
    try {
      setOpenBackdrop?.(true);
      const resp = await asyncSearchList({
        apiCode: "right",
        condition: { page: 1, limit: 90000, q: { email: data._id } },
      });
      const rights = resp?.data || [];
      const rightToSave: { [key: string]: any } = {};
      rights.forEach((r: any) => (rightToSave[r.module] = r));
      setRightObj(rightToSave);
    } catch (error) {
    } finally {
      setOpenBackdrop?.(false);
    }
  };

  useEffect(() => {
    getRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?._id]);

  return (
    <Stack gap={1}>
      {modules.map((module) => {
        return (
          <ModuleComponent
            key={module._id}
            module={module}
            rightObj={rightObj}
            userGroup={data}
            getRights={getRights}
          />
        );
      })}
    </Stack>
  );
}

export default PhanquyenSection;
